// Premium Design Tokens
// This file serves as the single source of truth for app colors.

export const COLORS = {
    // Brand Colors
    primary: '#4F46E5', // Indigo 600 - More vibrant, localized "Tech" feel
    primaryHover: '#4338CA', // Indigo 700

    // Dark Mode Palette (OLED/Deep)
    dark: {
        background: '#050505', // True Black / OLED
        header: '#0A0A0A',     // Slightly lighter for hierarchy
        surface: '#141414',    // Card backgrounds
        elevated: '#1f1f1f',   // Modals, drawers, dropdowns
        border: '#262626',     // Subtle borders
        controlBorder: '#434343',
        text: '#ffffff',
        textSecondary: 'rgba(255, 255, 255, 0.65)',
    },

    // Light Mode Palette (Clean/Airy)
    light: {
        background: '#F9FAFB', // Cool Gray 50
        header: '#ffffff',
        surface: '#ffffff',
        elevated: '#ffffff',
        border: '#e5e7eb',     // Gray 200
        controlBorder: '#e5e7eb',
        text: '#111827',       // Gray 900
        textSecondary: '#4B5563', // Gray 600
    }
};
